var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaceSharingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161205",
    "data-name": "Group 161205",
    transform: "translate(-784 -785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160831",
    "data-name": "Group 160831",
    transform: "translate(-110 417)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1899",
    "data-name": "Rectangle 1899",
    width: 100,
    height: 100,
    rx: 19,
    transform: "translate(894 368)",
    fill: "#f4f4fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "face-id-svgrepo-com",
    transform: "translate(806 807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M19.853,31.877C5.974,31.877,3,28.9,3,15.024",
    transform: "translate(0 21.884)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M31.877,15.024c0,13.878-2.975,16.853-16.853,16.853",
    transform: "translate(21.884 21.884)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M15.024,3C28.9,3,31.877,5.974,31.877,19.853",
    transform: "translate(21.884 0)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M8,14a14.1,14.1,0,0,0,22.562,0",
    transform: "translate(9.1 20.02)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M9,10.032V10",
    transform: "translate(10.92 12.74)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M15,10.032V10",
    transform: "translate(21.84 12.74)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M3,19.853C3,5.974,5.974,3,19.853,3",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceSharingIcon);
export default __webpack_public_path__ + "static/media/face-sharing-icon.73a63ba9916941e509f48867e7da6743.svg";
export { ForwardRef as ReactComponent };